<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterConfig"
    />
    <TableView
      :headers="headers"
      :items="allDataList"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :refreshTable="getDatasettlement"
      item-key="id"
      table-height="70vh"

    >     
        <template v-slot:body-prepend>
          <BodyFilterView
            :filters="filterData"
            :search.sync="search"
            :options.sync="options"
            @getDataParent="getDatasettlement"
          />
        </template>
        <template slot="action" slot-scope="{ item }">
         <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              center
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="viewItem(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>View</v-list-item-title>
                </v-list-item>
                <v-list-item @click="editItem(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteItem(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" md="4">
                  <v-card class="pa-2" outlined tile> Send To </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="8">
                  <v-card class="pa-2" outlined tile>
                    <span
                      v-for="(item, i) in channelDataType"
                      :key="i"
                      :value="item.value"
                      style="padding-right: 10px; font-size: 16px"
                    >
                      <span>
                        <input
                          id="channelData"
                          type="radio"
                          v-model="editedItem.channel_type"
                          @change="onChange($event)"
                          :value="item.text"
                        />
                        <label for="channelData">{{ item.text }}</label>
                      </span>
                    </span>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="4">
                  <v-card class="pa-2" outlined tile>
                    File Format
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="8">
                  <v-card class="pa-2" outlined tile>
                    <span
                      v-for="(item, i) in typeData"
                      :key="i"
                      :value="item.value"
                      style="padding-right: 10px; font-size: 16px"
                    >
                      <span>
                        <input
                          id="typeData"
                          type="radio"
                          v-model="editedItem.file_type"
                          :value="item.value"
                        />
                        <label for="typeData">{{ item.text }}</label>
                      </span>
                    </span>
                  </v-card>
                </v-col>
              </v-row>

              <div v-if="editedItem.channel_type == 'SFTP'">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.email"
                      label="Email"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_ip_address"
                      :error-messages="ipAddressErrors"
                      @change="$v.editedItem.sftp_ip_address.$touch()"
                      @blur="$v.editedItem.sftp_ip_address.$touch()"
                      label="IP SFTP"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_username"
                      :error-messages="usernameErrors"
                      @change="$v.editedItem.sftp_username.$touch()"
                      @blur="$v.editedItem.sftp_username.$touch()"
                      label="User Account"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_password"
                      :error-messages="passwordErrors"
                      @change="$v.editedItem.sftp_password.$touch()"
                      @blur="$v.editedItem.sftp_password.$touch()"
                      label="Password"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_port"
                      :error-messages="sftpportErrors"
                      @change="$v.editedItem.sftp_port.$touch()"
                      @blur="$v.editedItem.sftp_port.$touch()"
                      label="Server Port"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_path"
                      :error-messages="sftppathErrors"
                      @change="$v.editedItem.sftp_path.$touch()"
                      @blur="$v.editedItem.sftp_path.$touch()"
                      label="Server Path"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      v-model="editedItem.status_item"
                      :error-messages="statusErrors"
                      @change="$v.editedItem.status_item.$touch()"
                      @blur="$v.editedItem.status_item.$touch()"
                      :items="statusType"
                      label="Status"
                      item-text="text"
                      item-value="value"
                      :disabled="view"
                      clearable
                    />
                  </v-col>
                </v-row>
              </div>

              <div v-if="editedItem.channel_type == 'Email'">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.email"
                      :error-messages="emailErrors"
                      @change="$v.editedItem.email.$touch()"
                      @blur="$v.editedItem.email.$touch()"
                      label="Email"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_ip_address"
                      label="IP SFTP"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_username"
                      label="User Account"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_password"
                      label="Password"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_port"
                      label="Server Port"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sftp_path"
                      label="Server Path"
                      :disabled="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      v-model="editedItem.status_item"
                      :error-messages="statusErrors"
                      @change="$v.editedItem.status_item.$touch()"
                      @blur="$v.editedItem.status_item.$touch()"
                      :items="statusType"
                      label="Status"
                      item-text="text"
                      item-value="value"
                      :disabled="view"
                      clearable
                    />
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="close">
              Cancel
            </v-btn>

            <v-btn
              v-if="!view"
              color="blue darken-1"
              text
              :loading="loading"
              :disabled="execute"
              @click="saveData"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogView" max-width="600px">
      <v-card>
        <v-form>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <data-detail-row
                label="Nama Merchant/Agregator"
                :data="editedItem"
                :valueData="editedItem.name"
                noGutters
              />
              <data-detail-row
                label="Sent To"
                :data="editedItem"
                :valueData="editedItem.channel_type"
                noGutters
              />
              <data-detail-row
                label="File Format"
                :data="editedItem"
                :valueData="editedItem.file_type == 1 ? 'txt' : 'csv'"
                noGutters
              />
              <data-detail-row
                label="Email"
                :data="editedItem"
                :valueData="editedItem.email"
                noGutters
              />
              <data-detail-row
                label="IP SFTP"
                :data="editedItem"
                :valueData="editedItem.sftp_ip_address"
                noGutters
              />
              <data-detail-row
                label="User Account"
                :data="editedItem"
                :valueData="editedItem.sftp_username"
                noGutters
              />
              <data-detail-row
                label="Password"
                :data="editedItem"
                :valueData="editedItem.sftp_password"
                noGutters
              />
              <data-detail-row
                label="Server Port"
                :data="editedItem"
                :valueData="editedItem.sftp_port"
                noGutters
              />
              <data-detail-row
                label="Server Path"
                :data="editedItem"
                :valueData="editedItem.sftp_path"
                noGutters
              />
              <data-detail-row
                label="Status"
                :data="editedItem"
                :valueData="editedItem.status"
                noGutters
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="close">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
      @click:outside="closeDelete"
    >
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeDelete"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { validationMixin } from 'vuelidate';
import reportSettlementMixin from '../../components/report/settlement/reportSettlementMixin';

export default {
  components: {
    DataDetailRow: () => import('../../components/detail/DataDetailRow.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../components/@drontVue/components/BodyFilter"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
  },
  mixins: [validationMixin, reportSettlementMixin],

};
</script>
